import React from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import YellowDivider from "../dividers/YellowDivider";
import Button from "../singlecomponents/Button";
import ScrollSnapContainer from "../scrollsnapcontainer/ScrollSnapContainer";
import "../../stylesheet/components/sections/ContentPreview.scss";

const CategoryContentPreview: React.FC<{
  title: string;
  subtitle?: string;
  smallTitle?: boolean;
  linkTitle: string;
  link: string;
  children: JSX.Element[];
}> = ({ title, subtitle, smallTitle, linkTitle, link, children }) => {
  const { ready } = useTranslation();
  //const { i18n } = useTranslation();

  const getTitle = () => {
    if (!ready) {
      return (
        <Skeleton
          style={{
            width: "15vw",
            height: "5vh",
            marginBottom: "2vh",
          }}
        />
      );
    }
    if (smallTitle) {
      return <h3>{title}</h3>;
    }
    return <h2>{title}</h2>;
  };

  const getSubtitle = () => {
    if (subtitle?.length) {
      if (!ready) {
        return (
          <Skeleton
            style={{
              width: "20vw",
              height: "3vh",
            }}
          />
        );
      }
      return <h4>{subtitle}</h4>;
    }
  };

  const getLink = () => {
    if (ready) {
      return (
        <Link to={link}>
          <Button name={linkTitle} buttonWhite={true} />
        </Link>
      );
    }
    return (
      <Skeleton
        style={{
          width: "8vw",
          height: "4vh",
        }}
      />
    );
  };

  return (
    <div className="section-divider mt-3 mb-0 my-md-4 position-relative">
      <div className="cards-container">
        <div className="title-container">
          {getTitle()}
          <YellowDivider heading="h2" />
        </div>
        {getSubtitle()}
      </div>
      <div className="mobile-move-to-bottom">{getLink()}</div>
      <ScrollSnapContainer>{children}</ScrollSnapContainer>
    </div>
  );
};

export default CategoryContentPreview;
